import {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import {getCookie} from '@/utils/main';
import {isHelpPath} from '@/utils/help';
import {ROUTE} from '@/constants/main/route';
import globalDomains from '@/utils/global-domains';
import globalNavigation from '@/utils/global-navigation';
import {isMobile} from 'react-device-detect';

// const GLOBAL_HELP_URL = `${globalDomains.GLOBAL_HELP_AFREECATV}/hc/en/3-soop/`;
// TODO: 선배포 때 js-common 레포 배포하지 않아서 하드코딩으로 글로벌 고객센터 링크 넣어둠
const GLOBAL_HELP_URL = 'https://sooplive.helpshift.com/hc/en/3-soop/';

const getRedirectUrl = (pathname: string) => {
  return pathname === ROUTE.HELP.INQUIRY
    ? `${GLOBAL_HELP_URL}contact-us/`
    : GLOBAL_HELP_URL;
};

const useGlobalHelpRedirect = () => {
  const {pathname} = useLocation();
  const [isOverseasUser, setIsOverseasUser] = useState<boolean>(false);
  const isHelp = isHelpPath(pathname);

  useEffect(() => {
    if (!isHelp || !isMobile) {
      return;
    }
    const checkOverseasUser = async () => {
      const abroadChk = getCookie('AbroadChk') === 'OK';

      if (abroadChk) {
        setIsOverseasUser(true);
        return;
      }

      // abroadChk가 FAIL일 때(=한국 접속자) 접속 IP 국가로 한 번 더 체크
      try {
        const nation = await globalNavigation?.getIPNation?.();
        setIsOverseasUser(nation !== undefined && nation !== 'KR');
      } catch (error) {
        console.error('Failed to get IP nation:', error);
        setIsOverseasUser(false);
      }
    };

    checkOverseasUser();
  }, [isHelp]);

  useEffect(() => {
    if (isHelp && isOverseasUser && isMobile) {
      window.location.replace(getRedirectUrl(pathname));
    }
  }, [isHelp, isOverseasUser, pathname]);

  // 리다이렉트가 필요한 경우 true 반환
  const shouldRedirect = isHelp && isOverseasUser && isMobile;

  return shouldRedirect;
};

export default useGlobalHelpRedirect;
